import { adSizes } from "./adSlotsSizes";

// Prebid ad units configuration for all display slots.
// Each slot maps to its banner sizes and an array of bids.
// To add a bidding partner, uncomment a placeholder or add a new entry
// with real credentials from the partner.
const PREBID_AD_UNITS_CONFIG = {
  page1_header: {
    mediaTypes: {
      banner: { sizes: adSizes.page1_header }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [320, 50] }
      // },
    ]
  },
  page1_display: {
    mediaTypes: {
      banner: { sizes: adSizes.page1_display }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [300, 250] }
      // },
    ]
  },
  online_header: {
    mediaTypes: {
      banner: { sizes: adSizes.online_header }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [320, 50] }
      // },
    ]
  },
  online_display: {
    mediaTypes: {
      banner: { sizes: adSizes.online_display }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [300, 250] }
      // },
    ]
  },
  page2_header: {
    mediaTypes: {
      banner: { sizes: adSizes.page2_header }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [320, 50] }
      // },
    ]
  },
  page2_display: {
    mediaTypes: {
      banner: { sizes: adSizes.page2_display }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [300, 250] }
      // },
    ]
  },
  online2_header: {
    mediaTypes: {
      banner: { sizes: adSizes.online2_header }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [320, 50] }
      // },
    ]
  },
  online2_display: {
    mediaTypes: {
      banner: { sizes: adSizes.online2_display }
    },
    bids: [
      // {
      //   bidder: 'appnexus',
      //   params: { placementId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'rubicon',
      //   params: { accountId: 'REPLACE_ME', siteId: 'REPLACE_ME', zoneId: 'REPLACE_ME' }
      // },
      // {
      //   bidder: 'ix',
      //   params: { siteId: 'REPLACE_ME', size: [300, 250] }
      // },
    ]
  }
};

// Build Prebid adUnits array for the given slot names.
// Slots with empty bids[] are still included — Prebid handles them gracefully.
export function buildPrebidAdUnits(slotNames, adUnitCodePrefix) {
  return slotNames
    .filter((name) => PREBID_AD_UNITS_CONFIG[name])
    .map((name) => ({
      code: name,
      mediaTypes: PREBID_AD_UNITS_CONFIG[name].mediaTypes,
      bids: PREBID_AD_UNITS_CONFIG[name].bids
    }));
}

export { PREBID_AD_UNITS_CONFIG };
